<template>
  <div class="md-layout-item" v-if="blogs.models.length > 0">
    <vue-slick-carousel v-bind="settings">
      <template #prevArrow>
        <button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--left"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
      </template>
      <div class="md-layout-item" v-for="blog in blogs.models" :key="blog.id">
        <md-card class="md-card-blog mt-60 pb-20 cyan-900-bg">
          <vue-aspect-ratio
            ar="1:1"
            class="md-card-header md-card-header-image cyan-900-bg blog-image-width mt-20 mx-auto"
          >
            <img
              v-if="blog.image"
              :src="blog.image"
              class="img-fluid blog-image-width"
              alt="Blog image"
            />
          </vue-aspect-ratio>

          <md-card-content class="lh-normal">
            <p
              class="card-description mb-0 text-truncate-5 white"
              v-html="blog.content.rendered"
            ></p>
          </md-card-content>
          <div class="md-card-actions md-alignment-right">
            <md-button
              class="md-white md-card-left md-simple inactive-link card-category fw-600"
            >
              {{ dateFormatted(blog.date) }}
            </md-button>
            <md-button
              :href="blog.link"
              class="md-white md-simple card-category fw-600 ml-auto"
            >
              <md-icon class="fw-400">subject</md-icon> Read More
            </md-button>
          </div>
        </md-card>
      </div>

      <template #nextArrow>
        <button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--right"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
      </template>
      <template #customPaging>
        <button class="p-0"></button>
      </template>
    </vue-slick-carousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
// Don't remove css file until optimize
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import BlogPost from "@/api/models/BlogPost";
import { Collection } from "vue-mc";
import ApiLanding from "@/api/methods/ApiLanding";
import { DateFormatter, ErrorHelper } from "@/api/helpers";

export default {
  name: "BlogSection",
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      blogs: new Collection([], { model: BlogPost }),
      settings: {
        lazyLoad: "progressive",
        arrows: true,
        dots: true,
        infinite: false,
        dotsClass: "slick-dots",
        focusOnSelect: false,
        infinite: true,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: false,
        touchThreshold: 5,
        responsive: [
          {
            breakpoint: 7680,
            settings: {
              slidesToShow: 6,
              slidesToScroll: 6,
            },
          },
          {
            breakpoint: 3840,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 1920,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
            },
          },
          {
            breakpoint: 1266,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
          {
            breakpoint: 586,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      },
      logo: require("@/assets/img/blogImage.png"),
    };
  },
  methods: {
    async getData() {
      await ApiLanding.getBlogs()
        .then((response) => {
          this.blogs = new Collection(response.data, { model: BlogPost });
          this.filter();
        })
        .catch((e) => {
          let msg = ErrorHelper.message(e, null);
          if (msg) this.showError(this.name, msg);
        });
    },
    async filter() {
      this.blogs
        .filter((item) => {
          return item.featured_media != 0;
        })
        .each((blog, index) => {
          blog.media.set("id", blog.featured_media);
          blog.media
            .image(blog.featured_media)
            .then((res) => {
              if (res.response.data.source_url) {
                blog.set("image", res.response.data.source_url);
              }
            })
            .catch((e) => {
              let msg = ErrorHelper.message(e, null);
              if (msg) this.showError(this.name, msg);
            });
        });
    },

    dateFormatted(dateString) {
      return DateFormatter.UTCToLongString(DateFormatter.strToUTC(dateString));
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss">
@charset 'UTF-8';
/* Icons */
@font-face {
  font-family: "slick";
  src: url(data:application/font-woff;charset=utf-8;base64,d09GRgABAAAAAATsAA0AAAAAB2wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABGRlRNAAAE0AAAABoAAAAcdIcYB0dERUYAAAS0AAAAHAAAAB4AJwANT1MvMgAAAZwAAABRAAAAYFAQ/45jbWFwAAACAAAAAFcAAAFiIhFFt2dhc3AAAASsAAAACAAAAAj//wADZ2x5ZgAAAmgAAAE1AAACLD+btmBoZWFkAAABMAAAAC8AAAA2AAEx+2hoZWEAAAFgAAAAHAAAACQD5QIFaG10eAAAAfAAAAAQAAAAFgZKAEpsb2NhAAACWAAAABAAAAAQATYBoG1heHAAAAF8AAAAHQAAACAASwBHbmFtZQAAA6AAAADcAAABbgUngcJwb3N0AAAEfAAAAC4AAABFOXjBpHjaY2BkYGAA4vMGfuHx/DZfGbiZGEDgfGFFPZxWZVBlvM14G8jlYABLAwAT1QnNAHjaY2BkYGC8zcDAoMfEAAJANiMDKmABADBkAe942mNgZGBgYGdwYWBiAAEQycgAEnMA8xkACcgAkwAAAHjaY2BmYmCcwMDKwMDow5jGwMDgDqW/MkgytDAwMDGwcjKAQQNQCZBSYICCgDTXFAYHhkTFSYwP/j9g0GO8/f82A0QNA+NtsBIFBkYANHMN4wAAAHjaY2KAACYIVoVAAALCAJt42mNgYGBmgGAZBkYGEIgB8hjBfBYGByDNw8DBwARkMzAkKigpTlCc9P8/WB0S7/+i+4/uld4rgZoAB4xsDHAhRiYgwcSApoCBcsBMBTNYGGgGAEdEDyUAAAAAAAAAAAAAZgCKANABFnjadZBdToNAEMd3CrtAl5TQLtS0LCoN0A8SGkBI+mAfPET75B1896HppfQcvnII4w3cLYpW6k4ymdn9z8xvBwEKUQg11OgBIXAYWUEQR1uIZoFGpLGxKy3PqrIq8+waXIfJ+5mQSSvkvXwRqqocu1D39QMl2JgvN9zzhsyk1GRDz+OBfzMioCqx0rtdLYo0SiZTZttsOkmidBkveKibFF4Oep9SI46bqk3Twhp4iihUemrMWFPy2NRbthfqKkHi/PxlJLITZdAiSj6ouZ+tn9eZz78DuD9LZYB6bZ8rlCAUVuVdkULjxV4sIEysIc/KSyPmnJDdjhCOdQ0fCTliTX/tjH3ysWao+71qaNjHQjcQwrcuyl+WLZQthCMotJP/h+Xjazz+hfTeRWmG4zOiSyif/q1OtAAAAHjabY49asNAEIU/2ZJDfkiRIvXapUFCEqpcptABUrg3ZhEiQoKVfY9UqVLlGDlADpAT5e16IUWysMz3hjfzBrjjjQT/EjKpCy+4YhN5yZoxcirPe+SMWz4jr6S+5UzSa3VuwpTnBfc8RF7yxDZyKs9r5IxHPiKv1P9iZqDnyAvMQ39UecbScVb/gJO03Xk4CFom3XYK1clhMdQUlKo7/d9NF13RkIdfy+MV7TSe2sl11tRFaXYmJKpWTd7kdVnJ8veevZKc+n3I93t9Jnvr5n4aTVWU/0z9AI2qMkV42mNgYkAGjAzogB0sysTgwtDOyMTIzJlYVJRfnpOaVsIFZhVlpmeUAABuKQkSAAAAAAAB//8AAnjaY2BkYGDgAWIxIGZiYARCNiBmAfMYAAPgADV42mNgYGBkAIKrS9Q5QPT5wop6GA0APf8GGAAA)
    format("woff");
}
</style>
